import "./account-details-card.scss";
import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { IValidationGroup } from "../../../../hooks/validation-group/validation-group-hook";
import { FormField } from "../../../../components/form-field/form-field";
import { Input } from "../../../../components/inputs/input/input";
import ControlGroup from "../../../../components/layouts/control-group/control-group";
import Card from "../../../../components/layouts/card/card";
import AccountAvatar, { AVATAR_VARIANT } from "../account-avatar/account-avatar";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import AccountEditorStore from "../../stores/account-editor-store";
import ResetPasswordModal from "../reset-password-modal/reset-password-modal";
import { Button } from "../../../../components/inputs/button/button";
import currentAccountStore from "../../stores/current-account-store";
import { SelectDropdown } from "../../../../components/inputs/select-dropdown/select-dropdown";
import dashboardTranslationsStore from "../../../../dashboard-translation/stores/dashboard-translations-store";


interface IProps {
    validationGroup: IValidationGroup;
    account?: AccountEditorStore;
    resetPasswordEnabled?: boolean;
}
const AccountDetailsCard: React.FC<IProps> = observer(({ validationGroup, account, resetPasswordEnabled = false }) => {
    const [isShowPasswordChangeModal, setIsShowPasswordChangeModal] = useState(false);
    const localeOptions = Object.keys(dashboardTranslationsStore.locales).map(localeCode => ({
        value: localeCode,
        label: dashboardTranslationsStore.locales[localeCode]
    }));
    const currentDashboardLocale = account?.dashboardLocale ?? 'en';

    return (
        <Card
            toolbar={{
                title: "User Details"
            }}>
            <div className="account-details-card-content">
                <AccountAvatar account={account} variant={AVATAR_VARIANT.BIG} />
                <div className="account-personal-info-wrapper">
                    <ControlGroup>
                        <FormField label='Email' required>
                            <Input
                                required={!!account}
                                value={account?.email}
                                onChange={account?.setEmail}
                                validationGroup={validationGroup}
                                disabled={!account?.isNew && !currentAccountStore.isSysAdmin}
                            />
                        </FormField>
                        <FormField label='Password'>
                            <Button text="change"
                                onClick={() => setIsShowPasswordChangeModal(true)}
                                variant={BUTTON_VARIANTS.Secondary}
                                disabled={!resetPasswordEnabled || !account}
                            />
                        </FormField>
                    </ControlGroup>
                    <ControlGroup>
                        <FormField label='First Name'>
                            <Input
                                value={account?.first_name}
                                onChange={account?.setFirstName}
                                disabled={!account}
                            />
                        </FormField>
                        <FormField label='Last Name'>
                            <Input
                                value={account?.surname}
                                onChange={account?.setSurname}
                                disabled={!account}
                            />
                        </FormField>
                    </ControlGroup>
                    <ControlGroup>
                        <FormField label='UI Language'>
                            <SelectDropdown
                                disabled={!account || dashboardTranslationsStore.isLoading}
                                options={localeOptions}
                                value={localeOptions.find(locale => locale.value === currentDashboardLocale)}
                                onChange={(value) => account?.setDashboardLocale(value?.value as string)}
                            />
                        </FormField>
                    </ControlGroup>
                </div>
            </div>
            {(isShowPasswordChangeModal && account) && <ResetPasswordModal
                onClose={() => setIsShowPasswordChangeModal(false)}
                store={account}
            />}
        </Card>
    );
});

export default AccountDetailsCard;
